import { View, Text } from 'react-native'
import React from 'react'
import Svg, { Path, Rect } from 'react-native-svg';

const SupportIcon = ({ color, width, height }) => {
    return (
        <View>
            <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
                <Rect width="6" height="6" rx="1" transform="matrix(1 0 0 -1 14 10)" stroke={color} stroke-linecap="round" />
                <Path d="M10 14H14C14.9428 14 15.4142 14 15.7071 14.2929C16 14.5858 16 15.0572 16 16V18C16 18.9428 16 19.4142 15.7071 19.7071C15.4142 20 14.9428 20 14 20H10V14Z" stroke={color} stroke-linecap="round" />
                <Path d="M10 10C10 9.05719 10 8.58579 9.70711 8.29289C9.41421 8 8.94281 8 8 8H6C5.05719 8 4.58579 8 4.29289 8.29289C4 8.58579 4 9.05719 4 10V14H10V10Z" stroke={color} stroke-linecap="round" />
                <Path d="M10 20H6C5.05719 20 4.58579 20 4.29289 19.7071C4 19.4142 4 18.9428 4 18V14H10V20Z" stroke={color} stroke-linecap="round" />
            </Svg>
        </View>
    )
}

export default SupportIcon